import React, { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, useLocation, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import AuthCallback from "@/components/AuthCallback";
import PainelPage from "@/components/PainelPage";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Calculator from "@/components/Calculator";
import Process from "@/components/Process";
import Projects from "@/components/Projects";
import WhyUs from "@/components/WhyUs";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-ink flex items-center justify-center p-8">
                    <p className="font-hud text-sm text-slate-300">
                        Algo saiu do ar. Recarregue a página em instantes.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

const Site = () => (
    <div className="relative min-h-screen bg-ink text-slate-100 overflow-x-clip">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <Services />
            <Calculator />
            <Process />
            <Projects />
            <WhyUs />
            <Faq />
            <Contact />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
);

// Detect the OAuth session_id synchronously during render (prevents race conditions)
function AuthShell() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/painel" element={<PainelPage />} />
            <Route path="*" element={<Site />} />
        </Routes>
    );
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <AuthProvider>
                    <AuthShell />
                </AuthProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
